<template>
    <b-modal ref="mdlConfigurazioneTipoSoggetto" :title="title" centered no-close-on-backdrop no-close-on-esc
        hide-header-close size="lg" @ok="onOkMdlContabilitaTipoSoggetto" :okDisabled="!isValidazioneOK" @show="onShow">
        <b-row>
            <b-col cols="12" xs="12" sm="2" md="4" lg="4" xl="4">
                <label class="sa-label-data">Codice Struttura</label>
                <b-form-select v-model="jsonData.codiceAzienda" :value="null">
                    <template #first>
                        <b-form-select-option :value="null"> - Tutte -
                        </b-form-select-option>
                    </template>
                    <b-form-select-option v-for="tipoDoc in strutturaOptions" :key="tipoDoc.id"
                        :value="tipoDoc.codiceStruttura"> {{
                            tipoDoc.denominazione }} ({{ tipoDoc.codiceStruttura }}) </b-form-select-option>
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <label class="sa-label-data">Codice Tipo Soggetto</label>

                <b-input-group>
                    <b-form-input v-model="jsonData.codiceTipoSoggetto" :disabled="true"></b-form-input>
                    <b-input-group-append>
                        <b-button variant="outline-secondary"
                            :disabled="!isValidazioneOK || this.jsonData.primaryKey != undefined || !isNotValidElement('DESCRIZIONE')"
                            @click="calcolaCodiceSoggetto">
                            <i class="fas fa-cog"></i> </b-button>
                    </b-input-group-append>
                </b-input-group>


            </b-col>

            <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <label class="sa-label-data">Codice Soggetto Collegato</label>
                <b-form-select :options="getTipiBase" v-model="jsonData.codiceSoggettoCollegato"></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Descrizione Tipo Soggetto</label>
                <b-form-input
                    :class="{ 'fs-not-valid-input': !isNotValidElement('DESCRIZIONE'), 'text-uppercase': true }"
                    maxlength="10" v-model="jsonData.descrizioneTipo"></b-form-input>
                <small v-if="!isNotValidElement('DESCRIZIONE')" style="margin-left:10px">Inserire almeno 5
                    caratteri</small>
            </b-col>
        </b-row>
        <!-- <template #modal-footer>
			<b-button v-if="!isReadOnly" size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
			<b-button v-if="!isReadOnly" size="md" variant="outline-success" @click="onClickSalvaDocumento">Salva</b-button>
			<b-button v-if="isReadOnly" size="md" variant="outline-secondary" @click="onCloseModal">Chiudi</b-button>
		</template> -->
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>
<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import ContabilitaMixin from "../mixins/ContabilitaMixin";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import toast from "../../../template/layout/utility/sa-toast";

export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin, StruttureMixin, ContabilitaMixin],
    components: { ModalError },
    props: {
        items: {
            type: Array
        }
    },
    data() {
        return {
            title: null,
            pathResource: "/contabilitasoggettotipi",
            isReadOnly: false,
            jsonData: {
                id: null,
                codiceAzienda: null,
                codiceTipoSoggetto: null,
                descrizioneTipo: "",
                codiceSoggettoCollegato: null
            },
            optionsSoggettoCollegato: [{ text: "Tutti", value: "ALL" }],
            presidio: {},
        };
    },
    computed: {
        isValidazioneOK() {
            return this.validazione().esito;
        },
        getTipiBase() {
            let result = this.items.map(e => ({
                text: e.descrizioneTipo,
                value: e.codiceTipoSoggetto,
                o: e
            })).filter(e => e.value.length == 3)

            return [...result, { text: "Tutti", value: "ALL", o: { text: "Tutti", value: "ALL" } }]
        }
    },
    mounted() {
        this.struttureLoadData();
        this.setPresidio();

    },
    methods: {
        show(jsonData) {
            let me = this;
            this.title = "Nuovo Tipo Soggetto";
            if (jsonData?.id) {
                this.title = "Modifica Tipo Soggetto";
                this.jsonData = JSON.parse(JSON.stringify(jsonData));
                if (!this.jsonData.descrizioneTipo) {
                    this.jsonData.descrizioneTipo = '';
                }
            } else {
                this.resetJsonDataTipoSoggetto();
            }
            me.$refs.mdlConfigurazioneTipoSoggetto.show();
            this.setStrutturaUtente();
        },
        onCloseModal() {
            let me = this;
            me.jsonData = {};
            me.$emit("onCloseModal");
            me.$refs.mdlConfigurazioneTipoSoggetto.hide();
        },
        setStrutturaUtente() {
            console.log(this.presidio.codiceStruttura);
            let struttura = this.strutturaOptions.filter(e => e.codiceStruttura == this.presidio.codiceStruttura);
            if (struttura[0]) {
                this.jsonData.codiceAzienda = struttura[0].codiceStruttura;
            }

        },
        resetJsonDataTipoSoggetto() {
            this.jsonData = {
                id: null,
                codiceAzienda: null,
                codiceTipoSoggetto: null,
                descrizioneTipo: "",
                codiceSoggettoCollegato: null
            };
        },
        setPresidio() {
            let tmpPresidio = window.localStorage.getItem("presidio");
            if (tmpPresidio) {
                this.presidio = JSON.parse(tmpPresidio);
                this.strutturaLoadDataByCodice(this.presidio.codiceStruttura);
            }
        },
        calcolaCodiceSoggetto() {
            this.jsonData.codiceSoggettoCollegato
            if (!this.jsonData.descrizioneTipo) {
                this.jsonData.descrizioneTipo = "";
            }
            let indici = new Set();
            const max = this.jsonData.descrizioneTipo.length;
            indici.add(0);
            while (indici.size < 3) {
                if (!this.generaNumero(max) == 0) {
                    indici.add(this.generaNumero(max));
                }

            }
            const sortedIndici = [...indici].sort((a, b) => a - b);
            let [n1, n2, n3] = [...sortedIndici];
            const chart = this.jsonData.descrizioneTipo.toUpperCase().split('');
            this.jsonData.codiceTipoSoggetto = this.jsonData.codiceSoggettoCollegato + chart[n1] + chart[n2] + chart[n3];
        },
        generaNumero(max) {
            return Math.floor(Math.random() * max) + 1
        },

        validazione() {
            let esito = true;
            let msg = "";
            if (this.jsonData.descrizioneTipo == null || this.jsonData.descrizioneTipo.trim() == "") {
                msg += "Descrizione Tipo Soggetto  non valido ! #";
                esito = false;
            }
            if (this.jsonData.codiceSoggettoCollegato == null || this.jsonData.codiceSoggettoCollegato.trim() == "") {
                msg += "Codice Soggetto collegato  non valido ! #";
                esito = false;
            }
            return { esito: esito, msg: msg };
        },
        generaBtoast(validation) {
            toast.validation(validation)
        },
        contabilitaTipoDocumentoLoadDataSuccess(response) {
            this.tipoDocumentoOptions = response.data.data;
            console.log(this.tipoDocumentoOptions);
        },
        onShow() {

            if (!this.jsonData.id) {
                this.resetJsonDataTipoSoggetto();
            }


        },
        isNotValidElement(element) {
            switch (element) {
                case "DESCRIZIONE":
                    console.log(this.jsonData.descrizioneTipo.length > 5);

                    return this.jsonData.descrizioneTipo.length > 5;
                default:
                    break;
            }
        },
        onOkMdlContabilitaTipoSoggetto(bvModalEvent) {
            let me = this;
            bvModalEvent.preventDefault();
            let validation = me.validazione();
            if (!validation.esito) {
                me.generaBtoast(validation);
                return;
            }
            this.openShowModalLoading();
            this.$emit("beforeSave");
            this.saveResource(me.pathResource, me.jsonData, me.saveResourceSuccess, me.saveResourceError);
        },
        saveResourceSuccess() {
            this.$refs.mdlConfigurazioneTipoSoggetto.hide();
            this.$emit("afterSave");
            this.closeShowModalLoading();
            this.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        saveResourceError(error) {
            let message = error.response.data.messaggio;
            this.errorToast(message);
        },
    },
};
</script>
<style>
.fs-not-valid-input {
    border: 1px solid red !important;
}
</style>
